__turbopack_context__.v({
  "arcLayer": "BatteryLifeSection-module__AE2TOW__arcLayer",
  "arcShine": "BatteryLifeSection-module__AE2TOW__arcShine",
  "arcSvg": "BatteryLifeSection-module__AE2TOW__arcSvg",
  "arcWipeStack": "BatteryLifeSection-module__AE2TOW__arcWipeStack",
  "claimLayer": "BatteryLifeSection-module__AE2TOW__claimLayer",
  "counter": "BatteryLifeSection-module__AE2TOW__counter",
  "outer": "BatteryLifeSection-module__AE2TOW__outer",
  "ringDesktop": "BatteryLifeSection-module__AE2TOW__ringDesktop",
  "ringHost": "BatteryLifeSection-module__AE2TOW__ringHost",
  "ringImg": "BatteryLifeSection-module__AE2TOW__ringImg",
  "ringLayer": "BatteryLifeSection-module__AE2TOW__ringLayer",
  "ringMobile": "BatteryLifeSection-module__AE2TOW__ringMobile",
  "sideLabel": "BatteryLifeSection-module__AE2TOW__sideLabel",
  "stage": "BatteryLifeSection-module__AE2TOW__stage",
  "stat": "BatteryLifeSection-module__AE2TOW__stat",
  "textStack": "BatteryLifeSection-module__AE2TOW__textStack",
  "title": "BatteryLifeSection-module__AE2TOW__title",
  "titleLayer": "BatteryLifeSection-module__AE2TOW__titleLayer",
});
